import React, { useState } from 'react';
import { supabase } from '../services/supabaseClient';

/**
 * パスワード再設定画面
 * パスワードリセットメールのリンクからアプリに戻ってきた時に表示する
 */
export default function ResetPasswordScreen({ onDone }) {
  const [password, setPassword]       = useState('');
  const [confirm, setConfirm]         = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState('');
  const [done, setDone]               = useState(false);

  const handleSubmit = async () => {
    setError('');
    if (!password) { setError('新しいパスワードを入力してください'); return; }
    if (password.length < 6) { setError('パスワードは6文字以上にしてください'); return; }
    if (password !== confirm) { setError('パスワードが一致しません'); return; }
    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (err) {
      setError('パスワードの変更に失敗しました：' + err.message);
    } else {
      setDone(true);
    }
  };

  if (done) {
    return (
      <div className="auth-screen">
        <div className="auth-form-wrap">
          <div className="auth-done-icon">✅</div>
          <div className="auth-done-title">パスワードを変更しました</div>
          <div className="auth-done-sub">
            新しいパスワードでログインできます。
          </div>
          <button className="auth-btn-primary" onClick={onDone}>
            ログイン画面へ
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-screen">
      <div className="auth-form-wrap">
        <div className="auth-form-icon">🔏</div>
        <div className="auth-form-title">新しいパスワードを設定</div>

        <div className="auth-field">
          <label className="auth-label">新しいパスワード（6文字以上）</label>
          <div className="auth-input-wrap">
            <input
              className="auth-input"
              type={showPassword ? 'text' : 'password'}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
            />
            {password && (
              <button
                type="button"
                className="auth-eye-btn"
                onClick={() => setShowPassword(v => !v)}
                tabIndex={-1}
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="4"/>
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                )}
              </button>
            )}
          </div>
        </div>

        <div className="auth-field">
          <label className="auth-label">もう一度入力</label>
          <input
            className="auth-input"
            type={showPassword ? 'text' : 'password'}
            placeholder="••••••••"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
          />
        </div>

        {error && <div className="auth-error">{error}</div>}

        <button
          className="auth-btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? '…' : 'パスワードを変更する'}
        </button>
      </div>
    </div>
  );
}
